export enum RangeEnvironmentsPrivate {
  city = 'city',
  country = 'country',
  motorway = 'motorway',
  motorwayPlus = 'motorway+',
}

export interface RangeSimRimEnvironmentConstants {
  𝛿3: number;
  𝛿2: number;
  𝛿1: number;
  𝛿0: number;
}

export enum RangeTireSeasons {
  winter = 'winter',
  summer = 'summer',
  allSeason = 'allSeason',
}

export interface RangeSimRimData {
  'season': RangeTireSeasons;
  'size-string': string;
  'size-inch': number;
}

export interface RangeSimRim extends RangeSimRimData {
  R: number;
  environments: Record<
    RangeEnvironmentsPrivate,
    RangeSimRimEnvironmentConstants
  >;
}

export interface RangeSimEnvironmentConstants {
  𝛼3: number;
  𝛼2: number;
  𝛼1: number;
  𝛼0: number;
  𝛾4: number;
  𝛾3: number;
  𝛾2: number;
  𝛾1: number;
  𝛾0: number;
  Γ1: number;
  Γ0: number;
  𝜌0: number;
  𝜌1: number;
}

export interface RangeSimModelConstants {
  𝛽4: number;
  𝛽3: number;
  𝛽2: number;
  𝛽1: number;
  𝛽0: number;
}

export type RangeSimRimId = 'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6';

export type PayloadUi =
  | {
      kind: 'toggle';
    }
  | {
      kind: 'slider';
      maxPayload: number;
    };

export interface RangeSimModelData {
  𝛽4: number;
  𝛽3: number;
  𝛽2: number;
  𝛽1: number;
  𝛽0: number;
  rims: Partial<Record<RangeSimRimId, RangeSimRim>>;
  environments: Record<RangeEnvironmentsPrivate, RangeSimEnvironmentConstants>;
  payloadUi?: PayloadUi;
}
